export default __webpack_public_path__ + "static/media/SeminarioIes2026_BrendaCastillo.9122d7c3.jpg";